<script lang="ts" setup>
import ListEpisodes from "~/components/podcast/ListEpisodes.vue";

definePageMeta({
    layout: "no-container",
});
</script>

<template>
    <div>
        <ListEpisodes />
    </div>
</template>

<style scoped></style>
